import React from 'react';
import * as styles from './styles.module.scss';
import Icon from 'components/icons';

interface Props extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  title: string;
  price: string;
  description: string;
  image: string;
}

export const DesignItForMeRadioTile: React.FC<Props> = ({ title, price, description, image, ...inputProps }) => {
  const icon = inputProps?.checked ? 'radioChecked' : 'radioUnchecked';

  return (
    <label className={styles.label}>
      <input {...inputProps} type="radio" className={styles.input} />

      <img className={styles.image} src={image} alt="" width="100" />

      <div className={styles.content}>
        <div className={styles.title}>{title}</div>
        <div className={styles.price}>{price}</div>
        <p className={styles.description}>{description}</p>
      </div>

      <Icon icon={icon} className={styles.radioControl} />
    </label>
  );
};
